const C = {
  name: "Filter",
  dimensions: { width: 41, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
        <path d="M23.9927 24.1814V34.6499L18.5727 37.3804C18.3027 37.5113 17.9927 37.3098 17.9927 37.0176V24.1814L4.17268 8.06045H37.8027L23.9927 24.1814ZM38.9927 3.02267V6.04534H3.99268C3.44268 6.04534 2.99268 5.59194 2.99268 5.03778V2.01511H37.9927C38.5427 2.01511 38.9927 2.46851 38.9927 3.02267ZM38.9927 0H2.99268C1.89268 0 0.992676 0.906801 0.992676 2.01511V6.6801C0.992676 7.16373 1.16268 7.6272 1.48268 8L15.9927 24.927V38.4786C15.9927 39.0025 16.2627 39.4861 16.7027 39.7683C16.9427 39.9194 17.2227 40 17.4927 40C17.7227 40 17.9527 39.9496 18.1627 39.8388L24.8827 36.4534C25.5627 36.1108 25.9927 35.4156 25.9927 34.6499V24.937L40.5027 8.01008C40.8227 7.6272 40.9927 7.16373 40.9927 6.6801V2.01511C40.9927 0.906801 40.0927 0 38.9927 0Z"/>
    </g>
  `
};
export {
  C as Filter
};
